<script setup>
defineProps({
  name: String,
  size: String,
  outlined: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <span :class="outlined ? 'material-icons-outlined' : 'material-icons'">{{ name }}</span>
</template>

<style></style>
